import firebase from 'firebase/app';

import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/database';
import 'firebase/analytics';

const app = firebase.initializeApp({
  apiKey: 'AIzaSyA6qzhXDGah8XvkIn8Dpky-BbqNo4QCD-s',
  authDomain: 'colibras2020.firebaseapp.com',
  databaseURL: 'https://colibras2020.firebaseio.com',
  projectId: 'colibras2020',
  storageBucket: 'colibras2020.appspot.com',
  messagingSenderId: '1063475881682',
  appId: '1:1063475881682:web:9c0ef217b654a26e306f0b',
  measurementId: 'G-2QCGLCZ1PB'
});

export const firestore = app.firestore();
export const auth = () => app.auth();
export const storage = app.storage();
export const analytics = app.analytics();

if (process.env.NODE_ENV === 'development') {
  (global as any).firestore = firestore;
}

firestore.enablePersistence()
  .then()
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      console.error(`
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      `)
    } else if (err.code === 'unimplemented') {
      console.error(`
      // The current browser does not support all of the
      // features required to enable persistence
      `)
    }
  })

export const getFile = (ref: string) => {
  return storage.refFromURL(ref);
}
export const getDoc = (ref: string) => {
  return firestore.doc(ref);
}
